export default {
  verboseName: "Luogo",
  verboseNamePlural: "Luoghi",
  modelName: "Place",
  modelNamePlural: "Places",
  appName: "places",
  propName: "place",
  propNamePlural: "places",
}
